import { useState } from "react";
import { PhoneIcon } from "../../../../../../../../components/SvgComponents/Icons/PhoneIcon";

export function isInPageCameraAvailable() {
  return (
    typeof window !== "undefined" &&
    window.isSecureContext &&
    typeof navigator.mediaDevices?.getUserMedia === "function"
  );
}

function readFileAsDataUrl(file: File) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === "string") resolve(reader.result);
      else reject(new Error("Não foi possível ler a foto"));
    };
    reader.onerror = () =>
      reject(reader.error ?? new Error("Não foi possível ler a foto"));
    reader.readAsDataURL(file);
  });
}

interface NativeCameraCaptureProps {
  facingMode: "user" | "environment";
  onCapture: (dataUrl: string) => void;
  background: string;
  iconColor: string;
}

export const NativeCameraCapture: React.FC<NativeCameraCaptureProps> = ({
  facingMode,
  onCapture,
  background,
  iconColor,
}) => {
  const [reading, setReading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    setReading(true);
    setError("");
    try {
      onCapture(await readFileAsDataUrl(file));
    } catch {
      setError("Não foi possível ler a foto. Tente novamente.");
    } finally {
      setReading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 16,
        width: "80%",
        maxWidth: 320,
      }}
    >
      <div style={{ color: "#f7f7f7", fontSize: 13, textAlign: "center" }}>
        Neste endereço HTTP o Chrome não libera a câmera dentro da página. A
        foto será tirada pela câmera do celular.
      </div>
      <label
        style={{
          position: "relative",
          width: "100%",
          padding: "14px 18px",
          borderRadius: 12,
          background,
          color: "#292929",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
          cursor: reading ? "default" : "pointer",
          opacity: reading ? 0.7 : 1,
        }}
      >
        <PhoneIcon color={iconColor} />
        {reading ? "Carregando foto..." : "Abrir câmera"}
        <input
          type="file"
          accept="image/*"
          capture={facingMode}
          disabled={reading}
          onChange={handleChange}
          aria-label={
            facingMode === "user" ? "Tirar selfie" : "Tirar foto do documento"
          }
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            opacity: 0,
            cursor: "pointer",
          }}
        />
      </label>
      {error && (
        <div style={{ color: "#ffb4b4", fontSize: 12, textAlign: "center" }}>
          {error}
        </div>
      )}
    </div>
  );
};
